import Vue from 'vue'

import Button from '@/components/button/basic-button.vue'
import Modal from '@/components/modal/modal.vue'
import moment from 'moment'

export default Vue.extend({
  props: {
    content: Object
  },

  components: {
    'v-button': Button,
    'modal': Modal
  },

  methods: {
    handleClickClose () {
      this.$emit('close')
    },
    period() {
      return '契約期間：' + this.content.current_contract.period
    },

    formatDate() {
      return moment(this.content.current_contract.expire_at).diff(moment(new Date()), 'days')
    }
  }
})
